import { trpc } from "../trpc";

interface Input {
  folderId?: string; // optional folderId for invalidating the folder assets query
}

export function useChangeTableOwner(input?: Input) {
  const { folderId } = input || {};
  const utils = trpc.useUtils();

  const { mutateAsync, isPending, error, isSuccess, isError } =
    trpc.table.changeTableOwner.useMutation({
      onMutate: ({ tableId, ownerId }) => {
        utils.table.search.cancel();

        utils.table.search.setData({}, (old: any) => {
          if (!old?.data?.tables) {
            return old;
          }

          return {
            ...old,
            data: {
              ...old.data,
              tables: old.data.tables.map((table: any) => {
                if (table.id === tableId) {
                  return {
                    ...table,
                    ownerZapierCustomuserId: ownerId,
                    owner: table.owner
                      ? {
                          ...table.owner,
                          id: ownerId,
                        }
                      : undefined,
                  };
                }
                return table;
              }),
            },
          };
        });
      },

      onSettled: () => {
        utils.table.search.invalidate();
        if (folderId) {
          utils.asset.getHydratedFolderAssets.invalidate({
            folderId,
          });
        }

        // Invalidate permissions cache so kebab menu reflects new owner's permissions
        utils.permission.checkPermissions.invalidate();
      },
    });

  return {
    changeTableOwner: mutateAsync,
    error,
    isError,
    isLoading: isPending,
    isPending,
    isSuccess,
  };
}
